import React from 'react'
import { range } from 'lodash'
import { Table } from 'react-bootstrap'
import moment from 'moment-timezone'

import "./PerDayStats.less"

function ReservationsTableHalf({ days, firstRow, secondRow }) {
  return (
    <Table bordered striped className="cool-table table-fill per-day">
      <tbody>
        <tr>
          <td style={{fontWeight: "bold"}}>Day</td>
          {days.map(d => <th key={d} style={{  }}>{d}</th>)}
        </tr>
        <tr>
          <td style={{fontWeight: "bold", backgroundColor: "#308cce", color: "white"}}>Nº</td>
          {
            firstRow.map(rr => (
              <td key={rr.x} style={{ color: rr.y > 0 ? "black" : "lightgray",  }}>
                {rr.y}
              </td>
            ))
          }
        </tr>
        <tr>
          <td style={{fontWeight: "bold", backgroundColor: "#308cce", color: "white"}}>€</td>
          {
            secondRow.map(rr => (
              <td key={rr.x} style={{ color: rr.y > 0 ? "black" : "lightgray",  }}>
                {rr.y}
              </td>
            ))
          }
        </tr>
      </tbody>
    </Table>
  )
}

const ReservationsTable = ({ graphData, month }) => {
  const daysInMonth = moment(month, "YYYY-MM").daysInMonth()
  const daysRange = range(1, daysInMonth + 1)

  return (
    <div className="PerDayStats">
      <ReservationsTableHalf 
        days={daysRange.slice(0, 16)} 
        firstRow={graphData[0].slice(0, 16)} 
        secondRow={graphData[1].slice(0, 16)} 
      />
      <ReservationsTableHalf 
        days={daysRange.slice(16)} 
        firstRow={graphData[0].slice(16)} 
        secondRow={graphData[1].slice(16)} 
      />
    </div>
  )
}

export default ReservationsTable



// WEBPACK FOOTER //
// ./src/app/admin/components/tables/PerDayStats.jsx